import React, { useState, useRef } from 'react';
import DataResource from './../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Button from '../../../common/Button';

const Summary = (props) => {
    const today = new Date();
    const { carrier_id } = useParams();
    const [isGenerating, setIsGenerating] = useState(false);
    const dataResourceRef = useRef(null);

    const handleGenerateInvoice = async () => {
        // Get filter values from DataResource component's state
        const filter = dataResourceRef.current?.state?.filter || {};
        
        // Extract start and end dates from filter
        let startDate = filter.start_time_from;
        let endDate = filter.start_time_to;
        
        // If dates are not in filter, use defaults from URL query params or today
        if (!startDate) {
            const urlParams = new URLSearchParams(window.location.search);
            const startParam = urlParams.get('start_time_from');
            startDate = startParam ? new Date(startParam) : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
        } else if (typeof startDate === 'string') {
            startDate = new Date(startDate);
        }
        
        if (!endDate) {
            const urlParams = new URLSearchParams(window.location.search);
            const endParam = urlParams.get('start_time_to');
            endDate = endParam ? new Date(endParam) : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
        } else if (typeof endDate === 'string') {
            endDate = new Date(endDate);
        }

        if (!startDate || !endDate || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            alert('Please select both start and end dates');
            return;
        }

        if (window.confirm('Are you sure you want to generate an invoice for this period?')) {
            setIsGenerating(true);
            try {
                const response = await axios.post(
                    `/api/v2/admin/carriers/carriers/${carrier_id}/generate-invoice`,
                    {
                        start_date: startDate.toISOString().split('T')[0],
                        end_date: endDate.toISOString().split('T')[0]
                    }
                );

                if (response.data.result === 'OK') {
                    alert(`Invoice generated successfully!\nInvoice Number: ${response.data.data.invoice_number}\nTotal: ${response.data.data.total}`);
                } else {
                    alert(`Error: ${response.data.message || 'Failed to generate invoice'}`);
                }
            } catch (error) {
                console.error('Error generating invoice:', error);
                const errorMessage = error.response?.data?.message || error.message || 'An error occurred while generating the invoice';
                alert(`Error: ${errorMessage}`);
            } finally {
                setIsGenerating(false);
            }
        }
    };

    const data = {
        url: `/admin/carriers/carriers/${carrier_id}/summary`,
        filter: {},
        userFilterAdvanced: true,
        userfilter:
            [
                {
                    source: 'start_time',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },            
                {
                    source: 'destination',
                    label: 'Destination',
                    type: 'select',
                    default: ''
                },
                {
                    source: 'currency',
                    label: 'Sell Currency',
                    type: 'select',
                    default: ''
                },
                {
                    source: 'group_by_period',
                    label: 'Group by Period',
                    type: 'select',
                },
            ],
        metadata:
                [
                    {
                        label: 'Date',
                        source: 'ATRDATE',
                        type: 'text',
                    },
                   
                    {
                        label: 'MT Count',
                        source: 'MESSAGES_COUNT',
                        type: 'text'
                    },
                    {
                        label: 'MT Part Count',
                        source: 'MESSAGES_PARTS_COUNT',
                        type: 'text'
                    },
                    {
                        label: 'Sell Amount',
                        source: 'SELL_AMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Destination',
                        source: 'DESTINATION',
                        type: 'text'
                    },
                    {
                        label: 'Sell Currency',
                        source: 'SELL_CURRENCY',
                        type: 'select'
                    },
                    {
                        label: 'Buy Amount',
                        source: 'COST_AMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Profit',
                        source: 'PROFIT',
                        type: 'text'
                    }
                ],
    }

    return (
        <div>
           <Panel title = "SMS Summary">
           <div>
                <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        onClick={handleGenerateInvoice}
                        disabled={isGenerating}
                        value={isGenerating ? 'Generating...' : 'Create Invoice'}
                        bsStyle="primary"
                        icon="receipt"
                    />
                </div>
                <DataResource
                    ref={dataResourceRef}
                    data = {data}
                    {...props} 
                />
                </div>
            </Panel>
        </div>
    )
}

export default Summary;